export default __webpack_public_path__ + "static/media/item_11.eff52130.png";